import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Users, FolderKanban } from 'lucide-react';

const tabs = [
  { path: '/admin/users', label: 'Gestión de usuarios', icon: Users, testid: 'admin-tab-users' },
  { path: '/admin/projects', label: 'Gestor de proyectos', icon: FolderKanban, testid: 'admin-tab-projects' },
];

const AdminTabs = () => {
  const location = useLocation();
  return (
    <nav className="flex flex-wrap gap-2 mb-8" data-testid="admin-tabs">
      {tabs.map(({ path, label, icon: Icon, testid }) => {
        const active = location.pathname === path;
        return (
          <Link
            key={path}
            to={path}
            data-testid={testid}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-all duration-200 ${
              active
                ? 'bg-primary text-white shadow-md'
                : 'bg-white text-slate-600 border hover:text-primary hover:border-primary/40'
            }`}
          >
            <Icon size={16} />
            {label}
          </Link>
        );
      })}
    </nav>
  );
};

export default AdminTabs;
